import { parse2Digit } from "views/pages/manage/unAssigned/otherCharges/otherChargeDetails/OtherChargeList";

export const jodoColumn = [
  { label: "Original Due Date", hoverDescription: "Original Due Date" },
  { label: "Ref. No.", hoverDescription: "Ref. No" },
  { label: "Seq. No", hoverDescription: "Seq. No" },
  { label: "Payment Mode", hoverDescription: "Payment Mode" },
  { label: "Trans. Date & Time", hoverDescription: "Trans. Date & Time" },
  { label: "Payable Amt", hoverDescription: "Payble Amount" },
  { label: "Paid Amt", hoverDescription: "Paid Amount" },
  { label: "Status", hoverDescription: "Status" },
  { label: "Action", hoverDescription: "Action" },
];

export const paymentStatusStyle = {
  Bounced: {
    backgroundColor: "#F9D9D7",
    color: "#B32306",
    padding: "4px 11px",
    fontSize: "12px",
    borderRadius: "8px",
  },
  Settled: {
    backgroundColor: "#BBE2CE",
    color: "#0B442D",
    padding: "4px 11px",
    fontSize: "12px",
    borderRadius: "8px",
  },
  Debited: {
    backgroundColor: "#FFEDC8",
    color: "#705010",
    padding: "4px 11px",
    fontSize: "12px",
    borderRadius: "8px",
  },
  "Re-Initiated": {
    backgroundColor: "#FFEDC8",
    color: "#705010",
    padding: "4px 11px",
    fontSize: "12px",
    borderRadius: "8px",
  },
};

export const paymentStatusMapping = {
  BOUNCED: "Bounced",
  SETTLED: "Settled",
  DEBITED: "Debited",
};
export const formattedPrice = (x, isSymbol = true) => {
  if (!x) return "₹ 0.00";
  return (
    `${isSymbol ? "₹ " : ""}` +
    parse2Digit(x)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  );
};

export const COOLING_PERIOD = 3;

export const PROGRAM_ACTION_LIST=[ 'MATR', 'RADM', 'APPL', 'FOLO']